export default __webpack_public_path__ + "1b831f569f61ddc38fde6c389f598841.png";